"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseISODate = exports.formatDate = void 0;
var date_fns_1 = require("date-fns");
var locale_1 = require("date-fns/locale");
var formatDate = function (date, dateFormat) {
    if (dateFormat === void 0) { dateFormat = 'yyyy-MM-dd'; }
    if (!date) {
        return '';
    }
    if (typeof date === 'string') {
        return (0, date_fns_1.format)((0, date_fns_1.parseISO)(date), dateFormat, { locale: locale_1.pl });
    }
    if (typeof date !== 'undefined') {
        return (0, date_fns_1.format)(date, dateFormat, { locale: locale_1.pl });
    }
    return date ? date : '';
};
exports.formatDate = formatDate;
var parseISODate = function (value) {
    if (typeof value === 'string') {
        return (0, date_fns_1.parseISO)(value);
    }
    return value;
};
exports.parseISODate = parseISODate;
